<template>
  <div class="main">
    <div class="form">
      <div class="header" v-if="!showExamAndSurvey">
        <FileCard :icon="subject" :title="header" class="logo" />
        <div class="option">
          <div :class="{ disable: cantEdit }" v-if="!showList && !showExamAndSurveyTable" @click="$bvModal.show('deleteModal')" class="delete">
            <img src="../../../assets/images/dadbanan/delete.svg" />
            <span>حذف</span>
          </div>
          <div v-if="!showList && ['exam', 'survey'].includes(subject) && !showExamAndSurveyTable" class="view" @click="onShowEvent">
            <img src="../../../assets/images/dadbanan/view.svg" alt="" />
            <span>نمایش</span>
          </div>
          <div v-if="!showList && $route.query.act === 'train'" class="view-list" @click="showList = true">
            <img src="../../../assets/images/dadbanan/exam.svg" alt="" />
            <span>لیست اعضا</span>
          </div>
          <div v-if="showList || showExamAndSurveyTable" class="view-list" @click="showList = false">
            <img src="../../../assets/images/dadbanan/edit.svg" alt="" />
            <span>ویرایش</span>
          </div>
        </div>
      </div>

      <template v-if="!showList && !showExamAndSurvey && !showExamAndSurveyTable">
        <div class="mb-4">
          <BaseText :maxlength="subject === 'online' ? 90 : 2000" :value="model.title" @input="model.title = $event" :title="title" :placeholder="title" />
        </div>
        <div class="mb-4">
          <ComboBox
            :searchedData="weightItems"
            title="میزان سختی"
            placeholder="میزان سختی مورد نیاز برای انجام دادن فعالیت"
            :selectedValue="selectedWeight"
            @select="fillSelectedWeight"
            :inputStyle="comboStyle"
          />
        </div>
        <div class="mb-4">
          <BaseText :maxlength="2000" :value="model.point" @input="model.point = $event" title="امتیاز" placeholder="امتیاز" />
        </div>

        <div class="mb-4">
          <BaseText v-if="subject === 'exam'" :value="model.percentForPassing" @input="model.percentForPassing = $event" title="درصد نمره قبولی" placeholder="درصد نمره قبولی" />
        </div>

        <div v-if="subject === 'online'" class="mb-4">
          <DateTimeOffset :value="model.date" @input="model.date = $event" :title="date" :placeholder="date" :hasDefaultDate="false" />
        </div>
        <div v-if="subject === 'train'" class="mb-4">
          <div class="d-flex gap-2">
            <label>محدودیت زمانی </label>

            <Radio class="expire_date" :componentData="limitDate" v-model="model.practiceLimitation" />
          </div>
        </div>
        <div v-if="subject === 'online'" class="mb-4">
          <DateTimeOffset :value="hour" @input="hour = $event" title="ساعت دوره" placeholder="ساعت دوره" :hasDefaultDate="false" type="time" />
        </div>
        <div v-if="subject === 'link' || subject === 'file'" class="mb-4">
          <EditorInput :value="model.note" @input="model.note = $event" title="یادداشت" textAreaClass="align-items-center" />
        </div>
        <div v-if="subject === 'link'" class="mb-4">
          <EditorInput :value="model.linkDescription" @input="model.linkDescription = $event" title="لینک" textAreaClass="align-items-center" />
        </div>

        <div v-if="subject === 'pdf' || subject === 'file' || subject === 'train'" class="mb-4 upload">
          <UploadBox @fileBoxData="uploadedFile($event)" :componentData="url" :filesLength="1" placeholder="فایل خود را انتخاب کنید" />
        </div>
        <div class="mb-4">
          <EditorInput :value="model.description" @input="model.description = $event" title="توضیحات" textAreaClass="align-items-center" />
        </div>

        <div v-if="subject === 'online' || subject === 'video'" class="inner__style my-3">
          <div
            v-if="!model.onlineVideoLarge && !model.onlineVideoVeryMiniSmall && !model.onlineVideoMiniSmall && !model.onlineVideoSmall && !model.onlineVideoMedium"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="
              model.onlineVideoLarge === null &&
              model.onlineVideoVeryMiniSmall === null &&
              model.onlineVideoMiniSmall === null &&
              model.onlineVideoSmall === null &&
              model.onlineVideoMedium === null &&
              $route.query.act === 'online'
                ? $bvModal.show('allowUpload')
                : $bvModal.show('videoModal')
              cropperLoading = false
            "
          >
            <div v-if="!model.onlineVideoVeryMiniSmall && !model.onlineVideoMiniSmall && !model.onlineVideoSmall && !model.onlineVideoMedium && !model.onlineVideoLarge">
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">پس از برگزاری دوره و ضبط، فیلم دوره را بارگزاری کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-video">
                <div
                  class="remove-icon"
                  @click="
                    ;(model.onlineVideoLarge = null),
                      (model.onlineVideoVeryMiniSmall = null),
                      (model.onlineVideoMiniSmall = null),
                      (model.onlineVideoSmall = null),
                      (model.onlineVideoMedium = null)
                  "
                >
                  <i class="fa fa-times"></i>
                </div>

                <video
                  class="previewVideo"
                  :src="model.onlineVideoVeryMiniSmall || model.onlineVideoMiniSmall || model.onlineVideoSmall || model.onlineVideoMedium || model.onlineVideoLarge"
                  controls
                  id="player"
                />
              </div>
              <div style="with: 150%">
                <UploadProgress v-if="preview" :percent="100" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="['exam', 'survey'].includes(subject)" style="margin-right: 6rem">
          <b-button class="container-fluid my-4" variant="outline-primary" @click="createActivity">ساخت پرسشنامه</b-button>
        </div>
        <div class="display">
          <div class="display-title">نحوه نمایش</div>
          <Radio :componentData="displayTypes" :value="model.displayType" @input="model.displayType = $event" />
        </div>
        <div v-if="$route.query.act === 'online' || $route.query.act === 'video'" class="id">شناسه جلسه: {{ $route.query.fileId }}</div>
        <div class="p-3 d-flex flex-row justify-content-end mt-5" :class="{ disable: cantEdit }">
          <b-button variant="outline-secondary" @click="cancelAddActivity">انصراف</b-button>
          <Button @click.native="createActivity" :loading="submitLoading" text="ثبت" btnClass="upload-btn btn-border" />
        </div>
        <b-modal id="videoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeUpload">
          <template #modal-title>انتخاب ویدئو</template>
          <div class="p-3">
            <VideoUpload @preload="preload" :percent="percentCompleted" :loading="cropperLoading" @videoSourceChanged="uploadVideo" @close="closeUpload" />
          </div>
        </b-modal>
      </template>
      <TrainTable v-else-if="showList" />
      <Examination v-else-if="showExamAndSurvey" :courseSessionFileId="Number(sessionFileId)" @addLine="onAddLine" />
      <ExaminationTable v-else :courseSessionFileId="Number(sessionFileId) || Number(this.$route.query.fileId)" />
    </div>
    <Toast :title="toastText" :showToast="showToast" :error="error" />
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف این مورد اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteActivity">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="allowUpload" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="message">
        <img src="../../../assets/images/dadbanan/warning.svg" />
        <div class="text">
          دوره هنوز انجام نشده بعد از انجام دوره و ضبط<br />
          فیلم را بارگذاری کنید.
        </div>
      </div>
      <div class="accept" @click="$bvModal.hide('allowUpload')">متوجه شدم</div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import UploadBox from '../../common/form/formModules/UploadBox.vue'
import FileCard from '../../dadban/headlins/FileCard.vue'
import VideoUpload from '../../common/form/VideoUpload.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import skillUpCourseSessionProvider from '../../../services/skillUp/healline'
import Toast from '../../common/Toast.vue'
import UploadProgress from '../../common/UploadProgress.vue'
import TrainTable from './TrainTable.vue'
import Button from '../../common/Button.vue'
import axios from 'axios'
import Examination from './Examination.vue'
import ExaminationTable from './ExaminationTable.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'

let controller = new AbortController()
export default {
  props: {
    default: {
      type: Object,
    },
  },
  data() {
    return {
      limitDate: [
        { value: 'یک ساعت پس از شروع تمرین', key: 1 },
        { value: 'یک روز پس از شروع تمرین', key: 2 },
        { value: 'یک هفته پس از شروع تمرین', key: 3 },
        { value: 'یک ماه پس از شروع تمرین', key: 4 },
        { value: 'یک سال پس از شروع تمرین', key: 5 },
      ],
      comboStyle: 'color: #495057',
      selectedLimitDate: '',
      model: {
        title: '',
        description: '',
        percentForPassing: null,
        file: {
          url: '',
        },

        fileType: 0,
        displayType: 1,
        date: '',
        practiceLimitation: 0,
        hour: 0,
        note: '',
        linkDescription: '',
        order: 0,
        courseSessionId: +this.$route.query.id,
        onlineVideoLarge: null,
        onlineVideoVeryMiniSmall: null,
        onlineVideoMiniSmall: null,
        onlineVideoSmall: null,
        onlineVideoMedium: null,
        onlineVideo: null,
        point: '',
        weight: '',
      },
      url: [],
      hour: '',
      cropperLoading: false,
      showToast: false,
      percentCompleted: 0,
      showList: false,
      toastText: 'با موفقیت ثبت شد',
      error: false,
      submitLoading: false,
      preview: true,
      showExamAndSurvey: false,
      showExamAndSurveyTable: false,
      sessionFileId: undefined,
      cantEdit: false,
      weightItems: [
        {
          value: 'خیلی سخت',
          key: 1,
        },
        {
          value: 'سخت',
          key: 2,
        },
        {
          value: 'متوسط',
          key: 3,
        },
        {
          value: 'آسان',
          key: 4,
        },
        {
          value: 'خیلی آسان',
          key: 5,
        },
      ],
      selectedWeight: '',
    }
  },
  watch: {
    'model.date'(c) {
      if (!c?.includes('T') && c) {
        this.model.date = this.model.date.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },

    '$route.query.act'() {
      for (const key in this.model) {
        this.model[key] = ''
      }
    },
    hour(c) {
      this.model.hour = this.convertH2M(c)
    },
    '$route.query.fileId'() {
      this.checkPreData()
    },
    'model.file.name'(c) {
      if (c && this.subject === 'pdf' && !c.includes('.pdf')) {
        this.error = true
        this.toastText = 'لطفا فقط فایل با فرمت pdf  آپلود نمایید'
        this.showToast = true
        this.model.file = { url: '' }
        this.url = []
        setTimeout(() => {
          this.error = false
          this.toastText = 'ثبت با موفقیت انجام شد'
          this.showToast = false
        }, 5000)
      }
    },
    '$store.state.headlines.currentFileId'(c) {
      this.model.id = c
    },
  },
  computed: {
    subject() {
      return this.$route.query.act
    },
    displayTypes() {
      let o = [
        { key: 1, value: 'پیش نویس' },
        { key: 2, value: 'عمومی' },
        { key: 3, value: 'به زودی' },
        { key: 4, value: 'ثبت نام شدگان' },
      ]
      switch (this.subject) {
        case 'pdf':
          o.splice(1, 1)
          break
        case 'online':
          o.splice(1, 1)
          o.splice(1, 1)
          break
        case 'link':
          o.splice(1, 1)
          break
        case 'file':
          o.splice(1, 1)
          break
        case 'train':
          o.splice(1, 1)
          break
        case 'exam':
          o.splice(1, 1)
          break
        case 'survey':
          o.splice(1, 1)
          break
      }
      return o
    },
    title() {
      let t = ''
      switch (this.subject) {
        case 'video':
          t = 'عنوان ویدئو'
          break
        case 'pdf':
          t = 'عنوان فایل'
          break
        case 'file':
          t = 'عنوان فایل'
          break
        case 'online':
          t = 'عنوان دوره'
          break
        case 'link':
          t = 'عنوان'
          break
        case 'train':
          t = 'عنوان تمرین'
          break
        case 'exam':
          t = 'عنوان امتحان'
          break
        case 'survey':
          t = 'عنوان نظرسنجی'
          break
      }
      return t
    },
    date() {
      let t = ''
      switch (this.subject) {
        case 'online':
          t = 'تاریخ دوره'
          break

        case 'train':
          t = 'محدودیت زمانی'
          break
      }
      return t
    },
    header() {
      let t = ''
      switch (this.subject) {
        case 'video':
          t = 'ویدئو'
          break
        case 'pdf':
          t = 'pdf'
          break
        case 'file':
          t = 'فایل دانلود'
          break
        case 'online':
          t = 'جلسه آنلاین'
          break
        case 'link':
          t = 'لینک'
          break
        case 'train':
          t = 'تمرین'
          break
        case 'exam':
          t = 'امتحان'
          break
        case 'survey':
          t = 'نظرسنجی'
          break
      }
      return t
    },
  },
  mounted() {
    setTimeout(() => {
      this.cantEdit =
        (this.$route.path.includes('faculty') || this.$route.path.includes('support') || this.$route.path.includes('agent')) &&
        (localStorage.getItem('productStatus') == '4' || localStorage.getItem('productStatus') == '3')
    }, 500)
    this.checkPreData()
    this.model.practiceLimitation = this.model.practiceLimitation + 1
  },
  methods: {
    fillSelectedWeight(e) {
      if (!e) {
        this.model.weight = null
        return false
      }
      this.model.weight = this.weightItems.find((item) => item.value === e).key
      this.selectedWeight = this.weightItems.find((item) => item.value === e).value
    },
    cancelAddActivity() {
      this.$emit('cancelAddActivity')
    },
    onAddLine() {
      this.showExamAndSurvey = false
    },
    onShowEvent() {
      if (['exam', 'survey'].includes(this.subject)) this.showExamAndSurveyTable = true
    },
    async createActivity() {
      try {
        this.model.fileType = this.setFileType(this.$route.query.act)
        if (this.$route.query.act === 'online' || this.$route.query.act === 'video') {
          this.model.file.url = ''
        }

        for (const key in this.model) {
          if (key === 'file' && !this.model.file) {
            this.model[key] = { url: '' }
          }
          if (!this.model[key]) {
            delete this.model[key]
          }
        }

        if (this.$store.state.headlines.isUpdate || this.model.id) {
          if (this.model.id != this.$route.query.fileId) return
          this.$store.commit('headlines/SET_ISUPDATE', false)
          this.submitLoading = true

          await skillUpCourseSessionProvider.updateCourseSessionFile({
            ...this.model,
            onlineVideoLarge: this.model.onlineVideoLarge ? this.model.onlineVideoLarge : '',
            onlineVideoMedium: this.model.onlineVideoMedium ? this.model.onlineVideoMedium : '',
            onlineVideoSmall: this.model.onlineVideoSmall ? this.model.onlineVideoSmall : '',
            onlineVideoMiniSmall: this.model.onlineVideoMiniSmall ? this.model.onlineVideoMiniSmall : '',
            onlineVideoVeryMiniSmall: this.model.onlineVideoVeryMiniSmall ? this.model.onlineVideoVeryMiniSmall : '',
            percentForPassing: this.model.percentForPassing ? Number(this.model.percentForPassing) : null,
            practiceLimitation: this.model.practiceLimitation - 1,
            description:
              this.model.description && this.model.description.includes('ql-align-right') && this.model.description.includes('br') && this.model.description.length === 34
                ? undefined
                : this.model.description,
            linkDescription:
              this.model.linkDescription &&
              this.model.linkDescription.includes('ql-align-right') &&
              this.model.linkDescription.includes('br') &&
              this.model.linkDescription.length === 34
                ? undefined
                : this.model.linkDescription,
            note: this.model.note && this.model.note.includes('ql-align-right') && this.model.note.includes('br') && this.model.note.length === 34 ? undefined : this.model.note,
            weight: +this.model.weight,
            point: +this.model.point,
          })

          this.submitLoading = false
          this.model.onlineVideoLarge = !this.model.onlineVideoLarge ? null : this.model.onlineVideoLarge
          this.model.onlineVideoMedium = !this.model.onlineVideoMedium ? null : this.model.onlineVideoMedium
          this.model.onlineVideoMiniSmall = !this.model.onlineVideoMiniSmall ? null : this.model.onlineVideoMiniSmall
          this.model.onlineVideoSmall = !this.model.onlineVideoSmall ? null : this.model.onlineVideoSmall
          this.model.onlineVideoVeryMiniSmall = !this.model.onlineVideoVeryMiniSmall ? null : this.model.onlineVideoVeryMiniSmall

          this.$emit('update')
          this.showToast = true
          if (['exam', 'survey'].includes(this.subject)) {
            this.sessionFileId = this.$route.query.fileId
            this.showExamAndSurvey = true
          }

          return false
        }
        this.model.order = this.$store.state.headlines.items.find((item) => item.id === +this.$route.query.id).sessionFiles.length + 1
        if (!this.$store.state.headlines.isUpdate) {
          this.$store.commit('headlines/SET_ISUPDATE', false)

          this.submitLoading = true
          const req = await skillUpCourseSessionProvider.addCourseSessionFile({
            ...this.model,
            onlineVideoLarge: this.model.onlineVideoLarge ? this.model.onlineVideoLarge : '',
            onlineVideoMedium: this.model.onlineVideoMedium ? this.model.onlineVideoMedium : '',
            onlineVideoSmall: this.model.onlineVideoSmall ? this.model.onlineVideoSmall : '',
            onlineVideoMiniSmall: this.model.onlineVideoMiniSmall ? this.model.onlineVideoMiniSmall : '',
            onlineVideoVeryMiniSmall: this.model.onlineVideoVeryMiniSmall ? this.model.onlineVideoVeryMiniSmall : '',
            percentForPassing: this.model.percentForPassing ? Number(this.model.percentForPassing) : null,
            practiceLimitation: this.model.practiceLimitation - 1,
            description:
              this.model.description && this.model.description.includes('ql-align-right') && this.model.description.includes('br') && this.model.description.length === 34
                ? undefined
                : this.model.description,
            linkDescription:
              this.model.linkDescription &&
              this.model.linkDescription.includes('ql-align-right') &&
              this.model.linkDescription.includes('br') &&
              this.model.linkDescription.length === 34
                ? undefined
                : this.model.linkDescription,
            note: this.model.note && this.model.note.includes('ql-align-right') && this.model.note.includes('br') && this.model.note.length === 34 ? undefined : this.model.note,
            weight: +this.model.weight,
            point: +this.model.point,
          })
          this.submitLoading = false
          this.model.onlineVideoLarge = !this.model.onlineVideoLarge ? null : this.model.onlineVideoLarge
          this.model.onlineVideoMedium = !this.model.onlineVideoMedium ? null : this.model.onlineVideoMedium
          this.model.onlineVideoMiniSmall = !this.model.onlineVideoMiniSmall ? null : this.model.onlineVideoMiniSmall
          this.model.onlineVideoSmall = !this.model.onlineVideoSmall ? null : this.model.onlineVideoSmall
          this.model.onlineVideoVeryMiniSmall = !this.model.onlineVideoVeryMiniSmall ? null : this.model.onlineVideoVeryMiniSmall

          this.$emit('update')
          this.showToast = true
          setTimeout(() => {
            this.showToast = false
          }, 4000)
          if (['exam', 'survey'].includes(this.subject)) {
            this.sessionFileId = req.data.data
            this.showExamAndSurvey = true
          }
        }
      } catch (error) {
        this.error = true
        this.toastText = 'خطا! لطفا دوباره سعی کنید'
        this.showToast = true
        this.submitLoading = false
        setTimeout(() => {
          this.error = false
          this.toastText = 'ثبت با موفقیت انجام شد'
          this.showToast = false
        }, 5000)
      }
    },
    async deleteActivity() {
      const req = await skillUpCourseSessionProvider.deleteCourseSessionFile(+this.$route.query.fileId)
      if (req.status === 200) {
        this.$bvModal.hide('deleteModal')
        this.$emit('update')
        this.$store.commit('headlines/SET_FILE_CARD', true)
        this.$store.commit('headlines/SET_HEAD_LINE_FORM', false)
        this.$store.commit('headlines/SET_FILE_FORM', false)
        this.$router.push({
          query: {
            id: this.$route.query.id,
            new: true,
          },
        })
      }
    },
    convertH2M(time) {
      const timeParts = time.split(':')
      return Number(timeParts[0]) * 60 + Number(timeParts[1])
    },
    convertM2HM(min) {
      const minutes = min % 60
      const hours = Math.floor(min / 60)
      return `${hours}:${minutes}`
    },
    uploadedFile($event) {
      this.model.file = $event[0]
    },
    async uploadVideo(e) {
      this.preview = false
      try {
        this.cropperLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })

        this.model.onlineVideoLarge = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.percentCompleted = 0
          this.$bvModal.hide('videoModal')
          this.preview = true
        }, 2000)
      } catch (error) {
        this.cropperLoading = false
      }
      this.cropperLoading = false
    },
    closeUpload() {
      this.$bvModal.hide('videoModal')
      controller.abort()
      controller = new AbortController()
      this.percentCompleted = 0
      if (this.$route.query.act === 'online') {
        this.model.onlineVideo = null
      } else {
        this.model.file.url = ''
      }
    },
    setFileType(id) {
      let i = ''
      switch (id) {
        case 'video':
          i = 0
          break
        case 'pdf':
          i = 1
          break
        case 'file':
          i = 2
          break
        case 'link':
          i = 3
          break
        case 'online':
          i = 4
          break
        case 'train':
          i = 5
          break
        case 'exam':
          i = 6
          break
        case 'survey':
          i = 7
          break
      }
      return i
    },
    checkPreData() {
      if (this.$route.query.fileId) {
        const items = [...this.$store.state.headlines.items]
        items.forEach((item) => {
          item.sessionFiles.forEach((file) => {
            if (+this.$route.query.fileId === +file.id) {
              this.model = { ...file }
            }
          })
        })
        this.hour = this.convertM2HM(this.model.hour)
        if (this.model?.file?.url) {
          this.url = []
          this.url.push(this.model.file)
        }
        this.weightItems.filter((item) => {
          if (item.key === this.model.weight) {
            this.selectedWeight = item.value
          }
        })

        if (this.$route.query.act === 'video' || this.$route.query.act === 'online') {
          this.model.onlineVideoLarge = this.model.onlineVideoLarge.length > 0 ? this.model.onlineVideoLarge : null
          this.model.onlineVideoMedium = this.model.onlineVideoMedium.length > 0 ? this.model.onlineVideoMedium : null
          this.model.onlineVideoMiniSmall = this.model.onlineVideoMiniSmall.length > 0 ? this.model.onlineVideoMiniSmall : null
          this.model.onlineVideoSmall = this.model.onlineVideoSmall.length > 0 ? this.model.onlineVideoSmall : null
          this.model.onlineVideoVeryMiniSmall = this.model.onlineVideoVeryMiniSmall.length > 0 ? this.model.onlineVideoVeryMiniSmall : null
          this.model.file.url = ''
        }
      }
    },
    async goHeadlineDetail() {
      let token = await skillUpCourseSessionProvider.generateToken()
      token = token.data.data.token
      window.open(
        `https://dadbanan.cloudware.ir/show-headlines/${this.$route.params.courseId}?headlineId=${this.$route.query.id}&fileId=${this.$route.query.fileId}&token=${token}`,
        '_black',
      )
    },
    preload(e) {
      this.model.file.url = e
    },
  },
  components: {
    BaseText,
    EditorInput,
    DateTimeOffset,
    UploadBox,
    FileCard,
    VideoUpload,
    Radio,
    Toast,
    UploadProgress,
    TrainTable,
    Button,
    Examination,
    ExaminationTable,
    ComboBox,
  },
}
</script>

<style lang="scss" scoped>
.main {
  padding: 20px;
}
.upload {
  padding: 0 95px 0 5px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  .title {
    font-weight: 400;
    font-size: 18px;
    line-height: 15px;
    color: #4e4e56;
  }

  .option {
    display: flex;
  }
  .delete {
    background: rgba(244, 106, 106, 0.2);
    border-radius: 4px;
    display: flex;
    padding: 5px 10px;
    margin-left: 10px;
    max-height: 30px;
    cursor: pointer;
    span {
      color: #f46a6a;
      font-size: 14px;
      font-weight: 400;
      margin-right: 5px;
    }
  }

  .view {
    @extend .delete;
    background: rgba(52, 195, 143, 0.2);
    span {
      color: #34c38f;
    }
  }
  .view-list {
    @extend .delete;
    background: rgba(241, 180, 76, 0.2);
    span {
      color: #f1b44c;
    }
  }
}

.logo {
  margin-right: -20px;
}

.inner__style {
  background-color: white;
  padding-right: 95px;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}

.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 1000;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.id {
  font-size: 18px;
  margin-top: 16px;
}

video {
  width: 369px !important;
}
.display-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #495057;
}

.message {
  display: flex;
  .text {
    margin-right: 20px;
    position: relative;
    top: 10px;
    font-weight: bold;
  }
}

.accept {
  margin: auto;
  background: #2747ab;
  border-radius: 4px;
  color: #fff;
  width: 358px;
  text-align: center;
  padding: 6px 0;
  margin-top: 36px;
  cursor: pointer;
}

::v-deep #allowUpload___BV_modal_content_ {
  width: 418px !important;
}

::v-deep .bv-no-focus-ring {
  display: flex;
  flex-direction: row !important;
}

::v-deep .custom-control-inline {
  margin-left: 80px;
}

::v-deep .custom-control-label {
  margin-right: 10px;
}
::v-deep .labelStyle {
  margin: 0 !important;
}
::v-deep .expire_date .bv-no-focus-ring {
  flex-direction: column !important;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
::v-deep.btn-outline-primary:hover {
  color: #556ee6;
  background-color: #fff;
  border-color: #556ee6;
}
.disable {
  user-select: none;
  pointer-events: none;
  opacity: 0.5;
}
</style>
